//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faList } from '@fortawesome/pro-regular-svg-icons';
import CollapsiblePanel from '@motionelements/product2025/src/components/CollapsiblePanel.vue';

export default {
  name: 'ProductAttributesMobile',
  components: {
    CollapsiblePanel,
    ProductAttributes: () => import('@motionelements/product2025/src/sections/ProductAttributes.vue'),
  },
  props: {
    collapsed: {
      type: Boolean,
      default: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      faList,
    };
  },
};
